import { PropsWithChildren } from "react";

export default function ReturnDetailsHeaderBlock({
  children,
}: PropsWithChildren) {
  return <div className="flex flex-col space-y-1">{children}</div>;
}
